// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Footer------*/
.footer {
  background-color: #f2f3fa;
  width: 100%;
}

.footer-container {
  padding: 20px;
}

.footer-logo {
  text-align: start;
}

.footer-links {
  text-align: end;
}

.footer-links > span > a {
  color: #2c2f33;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.2s;
  margin-left: 10px;
  margin-right: 10px;
}

.footer-links > span > a:hover {
  color: #6366f1;
  text-decoration: underline;
}

.footer small {
  font-size: 0.75rem;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Header Nav------*/
.navbar {
  font-size: 0.875rem;
  font-family: sans-serif;
  font-weight: 600;
  z-index: 1000;
}

.nav_userProf {
  width: 25px;
  border-radius: 8px !important;
  background-color: #23272a;
}

.navbar-brand {
  color: #6366f1 !important;
}

.navbar-nav .nav-link {
  color: #6c757d !important;
}

.navbar-nav .nav-link:hover {
  color: #6366f1 !important;
}

.navbar .container {
  max-width: 85rem;
}

a.dropdown-item:hover {
  background-color: transparent;
  color: #6366f1 !important;
}

.header-blur {
  background-color: hsla(0, 0%, 100%, 0.8);
  backdrop-filter: saturate(180%) blur(5px);
  -webkit-backdrop-filter: saturate(180%) blur(5px);
}

.navbar .dropdown-menu a {
  font-size: 0.875rem;
  font-family: sans-serif;
  font-weight: 500;
  color: #6c757d !important;
}
.navbar .dropdown-menu a:hover {
  color: #6366f1 !important;
}

.navbar .dropdown-menu.show {
  right: 0;
  left: auto;
}

.navbar .dropdown-menu.show a:hover {
  background-color: #f7f7f7;
}

.navbar .dropdown-toggle::after {
  display: none !important;
}

.navbar .button-wrapper {
  background-color: transparent !important;
  cursor: auto !important;
}

#notification-icon {
  display: inline-flex;
  position: relative;
  align-items: center;
  padding: 0.75rem;
}

.notification-badge {
  display: inline-flex;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  justify-content: center;
  align-items: center;
  width: 0.5rem;
  height: 0.5rem;
  font-size: x-small;
  font-weight: bold;
  color: white;
  background-color: red;
  border-radius: 50px;
  border-width: 2px;
  border-color: white;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Login/Signup Forms------*/
div#auth-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
}

.auth-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 24px;
  flex: 1 1;
}

.auth-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  border-top: 1px solid #e0e0e0;
}

.login-card .form-control:-webkit-autofill {
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.login-card .form-control:focus {
  border: 1px solid #6366f1;
  box-shadow: none !important;
  background-color: rgba(255, 255, 255, 0.5);
}

.login-card .form-control {
  border: 1px solid rgba(44, 47, 51, 0.1);
  background-color: transparent;
}

.new-post-container .form-control:hover {
  border: 1px solid #6366f1;
}

.login-card.card {
  background-color: transparent;
  border: none;
  color: #2c2f33;
  font-weight: 500;
  width: 100%;
  max-width: 500px !important;
  padding: 1.5rem 2rem 2rem 2rem;
}

.btn-primary.show_hide-pw {
  background-color: #e0e7ff !important;
  color: #6366f1 !important;
}
.btn-primary.show_hide-pw:hover {
  background-color: #e0e7ff !important;
  color: #3730a3 !important;
}

.current-signedin .list-group-item:hover {
  transition: all 0.2s;
  background-color: #f7f7f7;
}

/* Chrome, Safari, Edge, Opera */
.otp-card,
input::-webkit-outer-spin-button,
.otp-card,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.otp-card input[type=number] {
  -moz-appearance: textfield;
}

.otp-card a {
  font-weight: 500;
  font-size: 14px;
  margin-top: 8px;
}

.otp-card .message-block {
  font-size: 14px;
  margin-bottom: 10px !important;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Dash Cards------*/
.create_event-card {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  padding: 20px;
  margin: 20px;
}

.create_event-card .card-header {
  background-color: transparent;
  border: none;
  border-radius: 5px;
  padding: 1rem 1rem;
}

.new-post-container {
  color: #2c2f33;
  border-radius: 5px;
}

.editor-card {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  margin-top: 20px;
  border: none !important;
}

.editor-card .card-header {
  background-color: transparent !important;
  padding: 1rem 1rem;
  border: none;
}

:is(.new-post-container, .editor-card) :is(.form-control, .form-control) {
  color: #2c2f33;
}

:is(.new-post-container, .editor-card) :is(.form-control:focus,
.form-control:focus,
.ql-editor:focus,
.dateTimePicker .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline) {
  border-color: #6366f1 !important;
  box-shadow: none !important;
}
:is(.new-post-container, .editor-card) :is(.form-control:focus,
.form-control:focus,
.ql-editor:focus,
.dateTimePicker .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline).ql-editor {
  border: 1px solid #6366f1 !important;
}
:is(.new-post-container, .editor-card) :is(.form-control:focus,
.form-control:focus,
.ql-editor:focus,
.dateTimePicker .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline).MuiOutlinedInput-notchedOutline {
  border-width: 1px;
}

:is(.new-post-container, .editor-card) :is(.form-control,
.form-control,
.dateTimePicker .css-1d3z3hw-MuiOutlinedInput-notchedOutline) {
  border: 1px solid rgba(44, 47, 51, 0.1);
}

.new-post-container .form-label {
  font-size: 0.9rem;
  font-weight: 600;
}

.event-card {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  padding: 20px;
  margin-top: 20px;
}

.event-card .card-header {
  background-color: transparent;
  border: none;
  border-radius: 5px;
  padding: 1rem 1rem;
}

.event-card .details_textarea {
  background-color: #f7f7f7;
  border-radius: 8px;
  padding: 25px;
}
.event-card .details_textarea:not(:first-child) {
  background-color: #ffffff !important;
}

.event-card .cta_button {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
}

.event-card_dash .dropdown-toggle.btn,
.event-card .dropdown-toggle.btn {
  padding: 0;
  justify-content: center;
  background-color: transparent;
  border: none;
}

.event-card_dash .dropdown-toggle::after,
.event-card .dropdown-toggle::after {
  display: none !important;
}

.event-card div[aria-labelledby=dropdown-basic] button {
  width: 100%;
}
.event-card div[aria-labelledby=dropdown-basic] button:hover {
  background-color: #e0e7ff !important;
}

/* .event-card div[aria-labelledby="dropdown-basic"] {
  min-width: 100px !important;
} */
.event-card_dash {
  margin: 20px;
  animation: displayTransition 0.2s;
}

@keyframes displayTransition {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.event-card_dash #card_header {
  padding: 0 0.4rem 10px 0.4rem;
}

.event-card_dash #card_header .card-timestamp {
  font-size: 12px;
}
.event-card_dash #card_header .card-timestamp::before {
  padding: 0 1.5px 0 1.5px;
  margin: 0 2px 0 2px;
  content: "•";
  font-weight: 700;
}

.userProf-img#card-img {
  width: 25px;
}

.event-card_dash .card {
  background-color: #ffffff !important;
  border-radius: 8px !important;
}

.event-card_dash .card .card-footer {
  background-color: #ffffff;
  border-top: none;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  text-align: end;
}

.event-card_dash .card .card-footer a {
  color: #6c757d !important;
  font-size: 14px;
}

.event-card_dash .event-brief small {
  font-size: 12px;
}

.event-card_dash .event-brief h4 {
  font-size: 16px;
  font-weight: 600;
}

.event-card_dash .event-brief p {
  font-size: 16px;
  font-weight: bold;
}

.event-card_dash div[role=group] button {
  max-height: 36px !important;
}

.ql-toolbar.ql-snow {
  border: 1px solid rgba(44, 47, 51, 0.1) !important;
  border-radius: 0.375rem 0.375rem 0 0 !important;
  border-bottom: none !important;
}

.ql-container.ql-snow {
  border: none !important;
}

.ql-editor {
  border: 1px solid rgba(44, 47, 51, 0.1) !important;
  border-radius: 0 0 0.375rem 0.375rem !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

.ql-editor span {
  font-size: 1rem !important;
}

.dateTimePicker.css-z3c6am-MuiFormControl-root-MuiTextField-root {
  display: block !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

.dateTimePicker :is(.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root,
.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root) {
  line-height: 1.5;
  padding: 0;
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  appearance: none;
  border-radius: var(--bs-border-radius);
}

.dateTimePicker input {
  padding: 0.375rem 0.75rem;
  width: 100%;
  height: auto;
  margin: 1px;
}

.dateTimePicker .css-1laqsz7-MuiInputAdornment-root {
  display: none !important;
}

:is(.dateTimePicker .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root:hover,
.dateTimePicker .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-error) .MuiOutlinedInput-notchedOutline {
  border-color: rgba(44, 47, 51, 0.1) !important;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Notification------*/
.notif-button-item {
  padding: 15px 30px 0 !important;
  width: 100%;
  text-align: left !important;
  text-decoration: none !important;
  color: #2c2f33 !important;
  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}

.notif-button-item:hover {
  background-color: #f2f3fa;
  color: #6366f1 !important;
}

.notif-button-item hr {
  margin-bottom: 0;
  color: #6366f1;
}

.notif-subHeader .content {
  padding: 5px 30px 0 !important;
  background-color: transparent;
}

.notif-mark {
  color: #6366f1;
  vertical-align: top;
}

.notif-details-header {
  font-size: 12px;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Resposive------*/
@media only screen and (min-width: 575px) {
  .responsive-elements {
    display: none;
  }
}
@media only screen and (max-width: 575px) {
  .navbar .navbar-collapse div {
    margin: 0 !important;
  }
  .navbar .navbar-collapse .navbar-nav:first-child .nav-link {
    background-color: #f7f7f7;
    margin-top: 5px;
    padding: 10px;
    border-radius: 8px;
  }
  .navbar .navbar-collapse .navbar-nav:nth-child(2) {
    display: none;
  }
}
@media only screen and (max-width: 640px) {
  .login-card.card {
    width: 100% !important;
  }
  .footer-links,
  .footer-logo {
    text-align: center;
  }
}
@media only screen and (max-width: 1024px) {
  .sidebar,
  .sidebar_calendarDash .card {
    display: none;
  }
  .dash-container {
    margin: 0 auto !important;
    flex-direction: column-reverse !important;
  }
  .dash-container .content {
    width: 100% !important;
  }
  .sidebar_eventDash,
  .sidebar_calendarDash {
    width: 100% !important;
  }
  .dash-container#calendar {
    margin: 0 auto !important;
  }
  .sidebar-wrapper {
    height: 100% !important;
  }
  .sidebar_calendarDash .sidebar-wrapper .sidebar_right {
    margin-top: 0 !important;
    padding: 0 !important;
  }
}
@media only screen and (min-width: 1450px) {
  .dash-container {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .navbar .container {
    max-width: 82rem;
  }
}
/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

.comment-card {
  background-color: #ffffff !important;
  border-radius: 8px !important;
  margin-top: 20px;
}

.comment-card textarea {
  background-color: transparent;
  resize: none;
  border: none;
  line-height: 1.5rem;
  font-size: 0.875rem;
  display: block;
  border-width: 0px;
}
.comment-card textarea:focus {
  box-shadow: none;
}

.user-img {
  width: 38px !important;
  height: 100%;
}

.comment-item {
  background-color: #ffffff;
  border-radius: 8px !important;
  margin: 0 0 10px 0px;
  padding: 10px;
  width: 100%;
}

.comment-item .card-header {
  background-color: transparent;
  border: none;
  border-radius: 5px;
}

.comment-item .card-body {
  padding: 5px 16px 5px 16px;
}

.comment-item .cta_button {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
}

.comment-item div[aria-labelledby=dropdown-basic] button {
  width: 100%;
}
.comment-item div[aria-labelledby=dropdown-basic] button:hover {
  background-color: #e0e7ff !important;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

.suggested img {
  border-radius: 4px;
}

.suggested li {
  margin-top: 10px;
  border: 1px solid rgba(0, 0, 0, 0.175) !important;
  border-radius: 8px;
}

.suggested .badge {
  font-size: 10px;
  background-color: #f2f3fa !important;
  color: #4338ca;
  align-self: center;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  --bs-border-opacity: 0.1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

/*------Calendar------*/
.calendar-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.calendar_container {
  width: 336px;
  height: 336px;
  display: flex;
  flex-direction: column;
}

.calendar_container .head {
  height: 38px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}

.calendar {
  border: 1px solid #e6e6e6;
  border-radius: 9px !important;
  background-color: #ffffff;
  overflow: hidden;
}

.calendar table {
  margin-bottom: 0 !important;
}

.calendar tbody tr:nth-last-of-type(1) {
  border-bottom: transparent;
}

.calendar tbody tr {
  border-style: hidden !important;
}

.calendar .table th {
  background-color: #f2f3fa;
  font-size: 14px;
  color: #6366f1;
  font-weight: 600;
  text-align: center;
}
.calendar .table th:first-child {
  border-top-left-radius: 7.5px;
}
.calendar .table th:last-child {
  border-top-right-radius: 7.5px;
}

.calendar .day p {
  margin: 0;
  font-size: 16px;
  font-weight: 400 !important;
  color: #adadad;
  text-align: center;
  transition: 0.2s;
  padding: 6px;
}
.calendar .day p:hover {
  background-color: #f2f3fa;
  border-radius: 6px !important;
  cursor: default;
}

.calendar .day {
  padding: 5px;
  width: 25px;
  height: 25px;
}

.calendar .currMonth p {
  color: #6c757d;
}

.calendar .selectedDay p {
  color: #6366f1;
  font-weight: bold !important;
  border-radius: 6px;
  background-color: #f2f3fa;
}

.calendar .hasEvent p {
  position: relative;
  color: #6366f1;
  font-weight: bold !important;
}
.calendar .hasEvent p::before {
  content: ".";
  position: absolute;
  bottom: 0.1em;
  left: 0;
  text-align: center;
  width: 100%;
  font-size: 35px;
}

.calendar_container .month-controls {
  display: flex;
  align-items: center;
}

.calendar_container .month-controls div {
  padding: 2px;
}
.calendar_container .month-controls div:hover {
  cursor: pointer;
}

.calendar_container .month-controls h6 {
  width: 75px;
  margin: 0 18px 0 18px !important;
  text-align: center;
}

.calendar_container .head span {
  font-size: 20px;
  font-weight: 600;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

.verticalNav .nav-link {
  padding-block: 6px;
  padding-inline: 8px;
  border-radius: 6px;
  margin: 1px;
  color: #2c2f33 !important;
}
.verticalNav .nav-link:hover {
  background-color: #f2f3fa;
}

.verticalNav .nav-link.active {
  font-weight: bold;
  background-color: #f2f3fa;
  border: 1px solid #cdd1ec;
}

#profile_sidebar {
  max-width: 20%;
}

#profile_sidebar .sidebar_left {
  padding-left: 0;
}

/*------Color Pallet------*/
/*------Font------*/
/*------Mixin------*/
body {
  padding: 0;
  margin: 0;
  font-family: "Roboto", sans-serif, Arial, Helvetica, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

h1 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 56px;
  font-weight: 600 !important;
  line-height: 67.2px;
  font-style: "normal";
}

h2 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 48px;
  font-weight: 600 !important;
  line-height: 57.6px;
  font-style: "normal";
}

h3 {
  font-family: "Poppins", "Roboto", "sans-serif", Arial, Helvetica !important;
  font-size: 22px;
  font-weight: 600 !important;
  line-height: 26.4px;
  font-style: "normal";
}

.content_1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

.content_sm1 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 16px;
  font-weight: 400 !important;
  line-height: 24px;
  font-style: "normal";
}

.content_sm3 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 12px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

.content_sm4 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 18px;
  font-weight: 600 !important;
  line-height: 27px;
  font-style: "normal";
}

.content_sm5 {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 18px;
  font-style: "normal";
}

p {
  font-family: "Roboto", sans-serif, Arial, Helvetica !important;
  font-size: 20px;
  font-weight: 400 !important;
  line-height: 30px;
  font-style: "normal";
}

a,
h5,
h6 {
  font-family: "Roboto", sans-serif, Arial, Helvetica;
}

.timeline {
  position: relative;
  border-left: 1px solid #cccccc;
  list-style: none;
  padding: 0 !important;
  margin-left: 20px;
  margin-right: 20px;
}

.timeline li {
  margin-bottom: 2.5rem;
  margin-left: 1.5rem;
  animation: displayTransition 0.2s;
}

@keyframes displayTransition {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.timeline .icon {
  position: absolute !important;
  display: flex !important;
  justify-items: center !important;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 9999px;
  left: -0.75rem;
  box-shadow: inset 0 0 0 12px #f7f7f7 !important;
}

.timeline li .badge {
  margin-left: 0.85rem;
  font-size: 12px;
  background-color: #f2f3fa !important;
  color: #4338ca;
  align-self: center;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  --bs-border-opacity: 0.1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
  font-weight: 500;
}

.timeline .icon svg {
  display: flex;
  justify-self: center;
  align-self: center;
  width: 1.1rem;
  height: 1.1rem;
  color: #6366f1;
}

.timeline li h5 a {
  font-size: 18px;
  font-weight: 600;
  color: #2c2f33;
}

.timeline li time {
  font-size: 14px;
  font-weight: 500;
}

.timeline li p {
  font-size: 16px;
}

.timeline_date {
  padding: 0.375rem 0 0.375rem 0;
  margin-bottom: 2rem;
  border-bottom: 1px solid #cccccc;
  height: 18px;
}

.timeline_date span {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  background-color: #f7f7f7 !important;
}

/*------General Components------*/
html,
body {
  background-color: #f7f7f7 !important;
  font-size: 1rem;
}

:any-link {
  text-decoration: none;
}

.titleText {
  color: #ffffff !important;
  font-size: 1.5rem;
  letter-spacing: 0px !important;
  font-weight: 700 !important;
  font-family: Poppins;
  padding: 0.4rem;
  background-color: #6366f1;
  width: max-content;
  border-radius: 8px;
}

.subTitle {
  color: #2c2f33 !important;
  font-size: 1.5rem;
  letter-spacing: normal !important;
  font-weight: 700 !important;
}

.section-header p, .section-header p.md p, .section-header p.sm p {
  margin-left: 0.25rem;
  font-size: 1.25rem !important;
  font-weight: 500 !important;
  margin-bottom: 8px;
  color: #5b616a;
}
.section-header p.sm {
  font-size: 0.75rem !important;
}
.section-header p.md {
  font-size: 0.875rem !important;
}

.btn-primary {
  background-color: #e0e7ff !important;
  color: #3730a3 !important;
  border: none !important;
  font-weight: 600 !important;
}
.btn-primary:hover {
  background-color: #3730a3 !important;
  color: #ffffff !important;
  border: none;
}

.btn-primary.btn-muted {
  background-color: rgb(246, 248, 250) !important;
  color: #6c757d !important;
  border: none !important;
  font-weight: 500 !important;
  border: 1px solid rgb(208, 215, 222) !important;
  padding: 0.25rem !important;
}
.btn-primary.btn-muted:hover {
  color: #6c757d !important;
}

.btn-cancel {
  background-color: transparent !important;
  color: #2c2f33 !important;
  border: none !important;
  font-weight: 600 !important;
}

.btn-cancel:hover {
  background-color: transparent !important;
  color: #6366f1 !important;
  border: none !important;
  font-weight: 600 !important;
}

.btn-danger {
  background-color: #fee2e2 !important;
  color: #dc2626 !important;
  border: none !important;
  font-weight: 600 !important;
}
.btn-danger:hover {
  background-color: #ef4444 !important;
  color: #ffffff !important;
  border: none;
}

:is(.btn-primary:focus, .btn:focus) {
  outline: none !important;
  box-shadow: none !important;
}

.btn-placements {
  background-color: transparent !important;
  color: #6366f1 !important;
  border: none !important;
  font-weight: 600 !important;
  padding: 2px 8px 4px 8px !important;
  margin: 1rem 0 0 0;
}

.btn-placements:not(:first-child) {
  margin: 1rem 0 0 1rem;
}

.formBtn.btn-primary {
  background-color: #e0e7ff !important;
  color: #3730a3 !important;
  border: none !important;
  font-weight: 600 !important;
  padding: 5px 10px !important;
}
.formBtn.btn-primary:hover {
  background-color: #3730a3 !important;
  color: #ffffff !important;
  border: none;
}

.postBtn-placements {
  background-color: transparent !important;
  color: #2c2f33 !important;
  border: none !important;
  font-weight: 600 !important;
  padding: 2px 8px 4px 8px !important;
}
.postBtn-placements:hover {
  background-color: transparent !important;
  color: #6366f1 !important;
}

.divider {
  color: #2c2f33;
  background-color: #2c2f33;
  height: 1;
}

.centerContent {
  display: flex;
  justify-content: center;
}

.toasts {
  width: -moz-fit-content !important;
  width: fit-content !important;
  top: 10px;
  margin-left: 4px;
  font-weight: 500;
  background-color: #ffffff !important;
  border: none !important;
}

.toasts-icon {
  padding: 2px;
  border-radius: 0.25rem;
}

div.content {
  background-color: #f7f7f7;
  height: 100%;
}

.userInfo-div button {
  padding: 0;
}

.vote_btn.user_vote, .vote_btn:hover {
  color: #5850ec !important;
  background-color: #e5edff !important;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  --bs-border-opacity: 0.1;
  border-color: rgba(88, 80, 236, var(--bs-border-opacity)) !important;
}

.vote_btn {
  padding: 0.2rem 0.4rem 0.2rem 0.4rem !important;
  font-size: 12px !important;
  font-weight: 600;
  background-color: #f9fafb !important;
  color: #475569 !important;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  --bs-border-opacity: 0.1;
  border-color: rgba(71, 85, 105, var(--bs-border-opacity)) !important;
}
.vote_btn svg {
  fill: transparent;
}

.vote_btn.user_vote svg {
  fill: #eac54f;
  color: #eac54f;
}

#vote_badge {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  background-color: #e5edff !important;
  color: #5850ec !important;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  --bs-border-opacity: 0.1;
  border-color: rgba(88, 80, 236, var(--bs-border-opacity)) !important;
  padding: 0.25rem 0.5rem 0.25rem 0.5rem;
}

.username_tags {
  color: #0d6efd;
  font-size: 14px;
}
.username_tags:hover {
  cursor: pointer;
}

.username_tags-dark {
  color: #2c2f33;
  font-size: 14px;
  font-weight: 600;
}
.username_tags-dark:hover {
  color: #0d6efd;
}

#badgeItem {
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  position: relative;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  --bs-border-opacity: 0.1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.pulse_dot {
  display: inline-flex;
  position: absolute;
  top: 0rem;
  right: 0rem;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 9999px;
  background-color: #dc2626;
}

.animate_pulse {
  display: inline-flex;
  position: absolute;
  top: 0rem;
  right: 0rem;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 9999px;
  background-color: #dc2626;
  opacity: 0.75;
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

.cursor-event {
  cursor: pointer;
}

/*------Main Dash------*/
.dash-container {
  display: flex;
  flex-direction: row;
  flex: 0 1 auto;
  min-height: 100vh;
  margin: 0 auto;
  max-width: 85rem;
}

.dash-container .content {
  flex: 1 1 auto;
  width: 60%;
}

.dash-container#main .container {
  max-width: 41rem;
}

.sidebar {
  width: 30%;
}

.sidebar-wrapper {
  width: 100%;
  overflow: auto;
  height: 100vh;
  position: sticky;
  top: 0;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.sidebar-wrapper::-webkit-scrollbar {
  display: none;
}

.sidebar_right {
  margin-top: 20px;
  padding-right: 10px;
}

.sidebar_left {
  margin-top: 20px;
  padding-left: 5px;
}

.sidebar .card {
  background-color: #ffffff;
  border-radius: 8px !important;
}

.content-wrapper {
  margin: 20px 0 20px 0;
}

/*------Event Dash------*/
.sidebar_eventDash-wrapper {
  width: 100%;
  height: 100%;
}

.sidebar_eventDash {
  width: 40%;
}

.sidebar_eventDash .card {
  background-color: #ffffff;
  border-radius: 8px;
}

/*------Calendar Dash------*/
.sidebar_calendarDash {
  width: 32%;
}

.sidebar_calendarDash .card {
  background-color: #ffffff;
  border-radius: 8px;
}

/*------Off-Canvas------*/
.offcanvas-header {
  background-color: #ffffff;
  color: #6366f1;
  padding: 20px 30px !important;
}

.offcanvas-body {
  background-color: #ffffff;
  padding: 0 !important;
}

.offcanvas.offcanvas-end {
  border-color: #f2f3fa !important;
}

/*------Modal------*/
.modal-header {
  border-top-right-radius: 8px !important;
  border-top-left-radius: 8px !important;
  border-color: transparent !important;
  padding: 0 !important;
}

.modal-title {
  color: #2c2f33 !important;
  font-weight: bold !important;
  font-size: 1.2rem !important;
}

.modal-content {
  border-radius: 8px !important;
  border-color: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1);
}

.modal-body {
  font-size: 1rem;
  color: rgb(107, 114, 128);
}

.modal-backdrop {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

/*------Image/Logo------*/
.userProf-img {
  width: 45px;
  border-radius: 4px !important;
}

.members-img {
  width: 1.5rem;
  border-radius: 9999px;
  background-color: #23272a;
}

.img-group img {
  margin-left: -0.6rem;
}

.members-count {
  display: inline-flex;
  overflow: hidden;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 9999px;
  background-color: #f7f7f7;
  color: #2c2f33;
  font-size: small;
}

.img-group span {
  margin-left: -0.6rem;
}

/*------pagination------*/
.paginate_div {
  display: flex;
  justify-content: flex-end;
  margin: 20px;
  padding: 10px 0;
}

.pagination #pagi-container {
  width: -moz-fit-content;
  width: fit-content;
  background-color: transparent;
  border-radius: 10px;
  padding: 0;
}

#pagi-container li {
  margin: 0 5px 0 5px;
}

.pagination .page-link {
  color: #23272a !important;
  background-color: transparent !important;
  border: none;
  font-weight: 500;
}

.pagination #prev {
  border-radius: 0.25rem !important;
}

.pagination #next {
  border-radius: 0.25rem !important;
}

.pagination .page-item.active .page-link {
  background-color: #e0e7ff !important;
  color: #3730a3 !important;
}

.pagination .page-link:hover {
  background-color: #e0e7ff !important;
  color: #3730a3 !important;
}

.pagination .page-item.disabled .page-link {
  color: #6c757d !important;
  font-weight: 400 !important;
}

/*------Listgroup------*/
.members-list.list-group .list-group-item {
  padding: 10px 0;
}

/*------Breadcrumb------*/
.breadcrumb :not(.breadcrumb-item.active) {
  color: #6366f1 !important;
}

/*------Table------*/
.custom-table {
  border: 1px solid #e6e6e6 !important;
  overflow: hidden;
  border-radius: 8px !important;
}

.custom-table tr {
  animation: displayTransition 0.2s;
}

@keyframes displayTransition {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.custom-table table {
  margin-bottom: 0 !important;
}

.custom-table th {
  background-color: #f2f3fa !important;
  font-weight: 600;
  font-size: 14px;
}

.custom-table tbody tr:hover td {
  background-color: #f2f3fa;
}

.custom-table tbody tr:nth-last-of-type(1) {
  border-bottom: transparent;
}

.custom-table .badge {
  background-color: #6366f1 !important;
  padding: 10px;
}

.custom-table .table-content {
  padding: 5px 2px 5px 2px;
}

.custom-table .table-content h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0;
}

.custom-table .table-content h4 a {
  color: #2c2f33;
}
.custom-table .table-content h4 a:hover {
  color: #0d6efd;
}

.custom-table .dropdown button {
  border: 1px solid #dee2e6;
  color: #2c2f33;
}

/*------Not Found------*/
.not-found {
  width: 100%;
  max-width: 100%;
  height: 100%;
  margin: 0rem auto 0rem auto;
  text-align: center;
  padding: 3rem;
}

.not-found a {
  text-decoration: underline;
  font-size: 14px;
}

/*------Alert------*/
.alert-dismissible {
  border-width: 0 !important;
  padding: 0.5rem 1rem !important;
}
.alert-dismissible .btn-close {
  font-size: 10px !important;
  padding: 1rem 1rem !important;
}

/*------Tag------*/
#dropdown-tag {
  font-size: 0.875rem;
  font-weight: 600 !important;
  color: #6366f1;
}

#dropdown-tag.dropdown-toggle::after {
  display: none !important;
}

/*------Loaders------*/
.loading_skeleton {
  border: 1px solid rgba(0, 0, 0, 0.175);
  margin-bottom: 10px;
  border-radius: 8px;
  background-color: #ffffff;
}

.loading_skeleton .title {
  width: 270px;
  height: 25px;
  background-color: #e5e7eb;
  border-radius: 4px;
}

.loading_skeleton .img {
  border-radius: 4px;
  padding: 20px;
  margin-top: 10px;
  background-color: #d1d5db;
  display: flex;
  justify-content: center;
}

.loading_skeleton .img svg {
  color: #e5e7eb;
}

.loading_skeleton .circle {
  width: 20px;
  height: 20px;
  background-color: #e5e7eb;
  border-radius: 1000px;
}

.loading_skeleton .btn {
  width: 67px;
  height: 30px;
  background-color: #e5e7eb;
  border-radius: 8px;
}

.loading_skeleton .title, .loading_skeleton .img, .loading_skeleton .circle, .loading_skeleton .btn {
  animation-duration: 2.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
  background: #ddd;
  background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);
  background-size: 1200px 100%;
}
@keyframes shimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/App.scss","webpack://./src/styles/index.scss","webpack://./src/styles/Footer.scss","webpack://./src/styles/Header.scss","webpack://./src/styles/Auth-forms.scss","webpack://./src/styles/Dash-cards.scss","webpack://./src/styles/Notification.scss","webpack://./src/styles/Responsive.scss","webpack://./src/styles/Comment.scss","webpack://./src/styles/Suggested.scss","webpack://./src/styles/Calendar.scss","webpack://./src/styles/Vertical-nav.scss","webpack://./src/styles/Timeline.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADxCF;;AC2CA;EACE,+EAAA;ADxCF;;AC4CA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADrCjD;;ACuCA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADhCjD;;ACkCA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;AD3BjD;;AC8BA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADvB7C;;ACyBA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADlB7C;;ACoBA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;ADb7C;;ACeA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADR7C;;ACUA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADH7C;;ACKA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADE7C;;ACAA;;;EAGE,mDA/EU;ADkFZ;;ACvGA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADsDF;;ACnDA;EACE,+EAAA;ADsDF;;AClDA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADyDjD;;ACvDA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;AD8DjD;;AC5DA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;ADmEjD;;AChEA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADuE7C;;ACrEA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;AD4E7C;;AC1EA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;ADiF7C;;AC/EA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADsF7C;;ACpFA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;AD2F7C;;ACzFA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADgG7C;;AC9FA;;;EAGE,mDA/EU;ADgLZ;;AErMA,qBAAA;AACA;EACE,yBAAA;EACA,WAAA;AFwMF;;AEtMA;EACE,aAAA;AFyMF;;AEvMA;EACE,iBAAA;AF0MF;;AExMA;EACE,eAAA;AF2MF;;AEzMA;EACE,cDVa;ECWb,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;AF4MF;;AEzMA;EACE,cDxBM;ECyBN,0BAAA;AF4MF;;AEzMA;EACE,kBDdQ;AD0NV;;AC1OA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADyLF;;ACtLA;EACE,+EAAA;ADyLF;;ACrLA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;AD4LjD;;AC1LA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADiMjD;;AC/LA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;ADsMjD;;ACnMA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;AD0M7C;;ACxMA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;AD+M7C;;AC7MA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;ADoN7C;;AClNA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADyN7C;;ACvNA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;AD8N7C;;AC5NA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADmO7C;;ACjOA;;;EAGE,mDA/EU;ADmTZ;;AGxUA,yBAAA;AACA;EFwCE,mBEvC4B;EFwC5B,uBExCsC;EFyCtC,gBEzCkD;EAClD,aAAA;AH6UF;;AG1UA;EACE,WAAA;EACA,6BAAA;EACA,yBFHe;ADgVjB;;AG1UA;EACE,yBAAA;AH6UF;;AG1UA;EACE,yBAAA;AH6UF;;AG1UA;EACE,yBAAA;AH6UF;;AG1UA;EACE,gBAAA;AH6UF;;AG1UA;EACE,6BAAA;EACA,yBAAA;AH6UF;;AG1UA;EACE,wCAAA;EACA,yCAAA;EACA,iDAAA;AH6UF;;AG1UA;EFEE,mBED4B;EFE5B,uBEFsC;EFGtC,gBEHkD;EAClD,yBAAA;AH+UF;AG9UE;EACE,yBAAA;AHgVJ;;AG7UA;EACE,QAAA;EACA,UAAA;AHgVF;;AG9UA;EACE,yBF/CgB;ADgYlB;;AG9UA;EACE,wBAAA;AHiVF;;AG9UA;EACE,wCAAA;EACA,uBAAA;AHiVF;;AG7UA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AHgVF;;AG9UA;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AHiVF;;ACtaA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADqXF;;AClXA;EACE,+EAAA;ADqXF;;ACjXA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADwXjD;;ACtXA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;AD6XjD;;AC3XA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;ADkYjD;;AC/XA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADsY7C;;ACpYA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;AD2Y7C;;ACzYA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;ADgZ7C;;AC9YA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADqZ7C;;ACnZA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;AD0Z7C;;ACxZA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;AD+Z7C;;AC7ZA;;;EAGE,mDA/EU;AD+eZ;;AIpgBA,iCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AJugBF;;AIpgBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AJugBF;;AIrgBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;AJwgBF;;AIrgBA;EACE,yDAAA;EAAA,iDAAA;AJwgBF;;AIrgBA;EACE,yBAAA;EACA,2BAAA;EACA,0CAAA;AJwgBF;;AIrgBA;EACE,uCAAA;EACA,6BAAA;AJwgBF;;AIrgBA;EACE,yBAAA;AJwgBF;;AIrgBA;EACE,6BAAA;EACA,YAAA;EACA,cH1Ca;EG2Cb,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,8BAAA;AJwgBF;;AIrgBA;EACE,oCAAA;EACA,yBAAA;AJwgBF;AItgBE;EACE,oCAAA;EACA,yBAAA;AJwgBJ;;AIngBA;EACE,oBAAA;EACA,yBH/DgB;ADqkBlB;;AIlgBA,gCAAA;AACA;;;;EAIE,wBAAA;EACA,SAAA;AJqgBF;;AIlgBA,YAAA;AACA;EACE,0BAAA;AJqgBF;;AIlgBA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;AJqgBF;;AIlgBA;EACE,eAAA;EACA,8BAAA;AJqgBF;;AClmBA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADijBF;;AC9iBA;EACE,+EAAA;ADijBF;;AC7iBA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADojBjD;;ACljBA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADyjBjD;;ACvjBA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;AD8jBjD;;AC3jBA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADkkB7C;;AChkBA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADukB7C;;ACrkBA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;AD4kB7C;;AC1kBA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADilB7C;;AC/kBA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADslB7C;;ACplBA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;AD2lB7C;;ACzlBA;;;EAGE,mDA/EU;AD2qBZ;;AKhsBA,yBAAA;AACA;EACE,oCAAA;EACA,6BAAA;EACA,aAAA;EACA,YAAA;ALmsBF;;AKjsBA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ALosBF;;AKlsBA;EACE,cJTa;EIUb,kBAAA;ALqsBF;;AKlsBA;EACE,oCAAA;EACA,6BAAA;EACA,gBAAA;EACA,uBAAA;ALqsBF;;AKnsBA;EACE,wCAAA;EACA,kBAAA;EACA,YAAA;ALssBF;;AKnsBA;EACE,cJ1Ba;ADguBf;;AKnsBA;;;;EASE,gCAAA;EACA,2BAAA;ALisBF;AKhsBE;;;;EACE,oCAAA;ALqsBJ;AKnsBE;;;;EACE,iBAAA;ALwsBJ;;AKpsBA;;;EAME,uCAAA;ALosBF;;AKjsBA;EACE,iBAAA;EACA,gBAAA;ALosBF;;AKhsBA;EACE,oCAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;ALmsBF;;AKhsBA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ALmsBF;;AKhsBA;EACE,yBJ/EgB;EIgFhB,kBAAA;EACA,aAAA;ALmsBF;AKlsBE;EACE,oCAAA;ALosBJ;;AKhsBA;EACE,sCAAA;EAAA,iCAAA;ALmsBF;;AKhsBA;;EAEE,UAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;ALmsBF;;AKhsBA;;EAEE,wBAAA;ALmsBF;;AKjsBA;EACE,WAAA;ALosBF;AKnsBE;EACE,oCAAA;ALqsBJ;;AKlsBA;;GAAA;AAKA;EACE,YAAA;EACA,iCAAA;ALmsBF;;AKjsBA;EACE;IACE,UAAA;ELosBF;EKlsBA;IACE,UAAA;ELosBF;AACF;AKlsBA;EACE,6BAAA;ALosBF;;AKlsBA;EACE,eAAA;ALqsBF;AKpsBE;EACE,wBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;ALssBJ;;AKnsBA;EACE,WAAA;ALssBF;;AKnsBA;EACE,oCAAA;EACA,6BAAA;ALssBF;;AKnsBA;EACE,yBJrJc;EIsJd,gBAAA;EACA,yCAAA;EACA,0CAAA;EACA,eAAA;ALssBF;;AKpsBA;EACE,yBAAA;EACA,eAAA;ALusBF;;AKpsBA;EACE,eAAA;ALusBF;;AKrsBA;EACE,eAAA;EACA,gBAAA;ALwsBF;;AKtsBA;EACE,eAAA;EACA,iBAAA;ALysBF;;AKtsBA;EACE,2BAAA;ALysBF;;AKrsBA;EACE,kDAAA;EACA,+CAAA;EACA,8BAAA;ALwsBF;;AKtsBA;EACE,uBAAA;ALysBF;;AKtsBA;EACE,kDAAA;EACA,+CAAA;EACA,mFAAA;ALysBF;;AKtsBA;EACE,0BAAA;ALysBF;;AKrsBA;EACE,yBAAA;EACA,mFAAA;ALwsBF;;AKtsBA;;EAKE,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,mCAAA;EACA,4BAAA;EACA,gBAAA;EACA,sCAAA;ALssBF;;AKnsBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ALssBF;;AKnsBA;EACE,wBAAA;ALssBF;;AKnsBA;;EAME,8CAAA;ALksBF;;AC76BA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;AD43BF;;ACz3BA;EACE,+EAAA;AD43BF;;ACx3BA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;AD+3BjD;;AC73BA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADo4BjD;;ACl4BA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;ADy4BjD;;ACt4BA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;AD64B7C;;AC34BA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADk5B7C;;ACh5BA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;ADu5B7C;;ACr5BA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;AD45B7C;;AC15BA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADi6B7C;;AC/5BA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADs6B7C;;ACp6BA;;;EAGE,mDA/EU;ADs/BZ;;AM3gCA,2BAAA;AACA;EACE,+BAAA;EACA,WAAA;EACA,2BAAA;EACA,gCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;EACA,2BAAA;AN8gCF;;AM5gCA;EACE,yBLXY;EKYZ,yBAAA;AN+gCF;;AM7gCA;EACE,gBAAA;EACA,cLjBM;ADiiCR;;AM9gCA;EACE,8BAAA;EACA,6BAAA;ANihCF;;AM/gCA;EACE,cLxBM;EKyBN,mBAAA;ANkhCF;;AM/gCA;EACE,eAAA;ANkhCF;;AChjCA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;AD+/BF;;AC5/BA;EACE,+EAAA;AD+/BF;;AC3/BA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADkgCjD;;AChgCA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADugCjD;;ACrgCA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;AD4gCjD;;ACzgCA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADghC7C;;AC9gCA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADqhC7C;;ACnhCA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;AD0hC7C;;ACxhCA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;AD+hC7C;;AC7hCA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADoiC7C;;ACliCA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADyiC7C;;ACviCA;;;EAGE,mDA/EU;ADynCZ;;AO9oCA,wBAAA;AAEA;EACE;IACE,aAAA;EPgpCF;AACF;AO7oCA;EACE;IACE,oBAAA;EP+oCF;EO7oCA;IACE,yBNTc;IMUd,eAAA;IACA,aAAA;IACA,kBAAA;EP+oCF;EO7oCA;IACE,aAAA;EP+oCF;AACF;AO5oCA;EACE;IACE,sBAAA;EP8oCF;EO5oCA;;IAEE,kBAAA;EP8oCF;AACF;AO3oCA;EACE;;IAEE,aAAA;EP6oCF;EO3oCA;IACE,yBAAA;IACA,yCAAA;EP6oCF;EO3oCA;IACE,sBAAA;EP6oCF;EO3oCA;;IAEE,sBAAA;EP6oCF;EO3oCA;IACE,yBAAA;EP6oCF;EO3oCA;IACE,uBAAA;EP6oCF;EO1oCA;IACE,wBAAA;IACA,qBAAA;EP4oCF;AACF;AOzoCA;EACE;IACE,kBAAA;IACA,mBAAA;EP2oCF;EOzoCA;IACE,gBAAA;EP2oCF;AACF;AChtCA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;AD8pCF;;AC3pCA;EACE,+EAAA;AD8pCF;;AC1pCA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADiqCjD;;AC/pCA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADsqCjD;;ACpqCA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;AD2qCjD;;ACxqCA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;AD+qC7C;;AC7qCA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADorC7C;;AClrCA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;ADyrC7C;;ACvrCA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;AD8rC7C;;AC5rCA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADmsC7C;;ACjsCA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADwsC7C;;ACtsCA;;;EAGE,mDA/EU;ADwxCZ;;AQ5yCA;EACE,oCAAA;EACA,6BAAA;EACA,gBAAA;AR+yCF;;AQ7yCA;EACE,6BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBPMQ;EOLR,cAAA;EACA,iBAAA;ARgzCF;AQ9yCE;EACE,gBAAA;ARgzCJ;;AQ5yCA;EACE,sBAAA;EACA,YAAA;AR+yCF;;AQ3yCA;EACE,yBPxBc;EOyBd,6BAAA;EACA,oBAAA;EACA,aAAA;EACA,WAAA;AR8yCF;;AQ3yCA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;AR8yCF;;AQ3yCA;EACE,0BAAA;AR8yCF;;AQ3yCA;EACE,sCAAA;EAAA,iCAAA;AR8yCF;;AQ3yCA;EACE,WAAA;AR8yCF;AQ7yCE;EACE,oCAAA;AR+yCJ;;ACl2CA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADizCF;;AC9yCA;EACE,+EAAA;ADizCF;;AC7yCA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADozCjD;;AClzCA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADyzCjD;;ACvzCA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;AD8zCjD;;AC3zCA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADk0C7C;;ACh0CA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADu0C7C;;ACr0CA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;AD40C7C;;AC10CA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADi1C7C;;AC/0CA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADs1C7C;;ACp1CA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;AD21C7C;;ACz1CA;;;EAGE,mDA/EU;AD26CZ;;ASh8CA;EACE,kBAAA;ATm8CF;;ASh8CA;EACE,gBAAA;EACA,iDAAA;EACA,kBAAA;ATm8CF;;ASh8CA;EACE,eAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,uFAAA;EACA,wBAAA;EACA,8EAAA;ATm8CF;;ACp9CA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADm6CF;;ACh6CA;EACE,+EAAA;ADm6CF;;AC/5CA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADs6CjD;;ACp6CA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;AD26CjD;;ACz6CA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;ADg7CjD;;AC76CA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADo7C7C;;ACl7CA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADy7C7C;;ACv7CA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;AD87C7C;;AC57CA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADm8C7C;;ACj8CA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADw8C7C;;ACt8CA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;AD68C7C;;AC38CA;;;EAGE,mDA/EU;AD6hDZ;;AUljDA,uBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AVqjDF;;AUnjDA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AVsjDF;;AUnjDA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AVsjDF;;AUnjDA;EACE,yBAAA;EACA,6BAAA;EACA,yBTtBc;ESuBd,gBAAA;AVsjDF;;AUnjDA;EACE,2BAAA;AVsjDF;;AUnjDA;EACE,0BAAA;AVsjDF;;AUnjDA;EACE,+BAAA;AVsjDF;;AUnjDA;EACE,yBTxCY;ESyCZ,eAAA;EACA,cT3CM;ES4CN,gBAAA;EACA,kBAAA;AVsjDF;AUrjDE;EACE,6BAAA;AVujDJ;AUrjDE;EACE,8BAAA;AVujDJ;;AUnjDA;EACE,SAAA;EACA,eAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AVsjDF;AUpjDE;EACE,yBT/DU;ESgEV,6BAAA;EACA,eAAA;AVsjDJ;;AUljDA;EACE,YAAA;EACA,WAAA;EACA,YAAA;AVqjDF;;AUljDA;EACE,cTvEU;AD4nDZ;;AUljDA;EACE,cTjFM;ESkFN,4BAAA;EACA,kBAAA;EACA,yBTnFY;ADwoDd;;AUljDA;EACE,kBAAA;EACA,cTzFM;ES0FN,4BAAA;AVqjDF;AUnjDE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AVqjDJ;;AUjjDA;EACE,aAAA;EACA,mBAAA;AVojDF;;AUjjDA;EACE,YAAA;AVojDF;AUnjDE;EACE,eAAA;AVqjDJ;;AUjjDA;EACE,WAAA;EACA,gCAAA;EACA,kBAAA;AVojDF;;AUjjDA;EACE,eAAA;EACA,gBAAA;AVojDF;;AChrDA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;AD+nDF;;AC5nDA;EACE,+EAAA;AD+nDF;;AC3nDA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADkoDjD;;AChoDA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;ADuoDjD;;ACroDA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;AD4oDjD;;ACzoDA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADgpD7C;;AC9oDA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;ADqpD7C;;ACnpDA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;AD0pD7C;;ACxpDA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;AD+pD7C;;AC7pDA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;ADoqD7C;;AClqDA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADyqD7C;;ACvqDA;;;EAGE,mDA/EU;ADyvDZ;;AW9wDA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AXixDF;AWhxDE;EACE,yBVLU;ADuxDd;;AW9wDA;EACE,iBAAA;EACA,yBVXY;EUYZ,yBAAA;AXixDF;;AW9wDA;EACE,cAAA;AXixDF;;AW9wDA;EACE,eAAA;AXixDF;;ACvyDA,2BAAA;AAeA,mBAAA;AAQA,oBAAA;AA8BA;EACE,UAAA;EACA,SAAA;EACA,sMAAA;EAGA,mCAAA;EACA,kCAAA;EACA,uBAAA;ADsvDF;;ACnvDA;EACE,+EAAA;ADsvDF;;AClvDA;EAvBE,2EAAA;EACA,eAuB4B;EAtB5B,2BAAA;EACA,mBAqBuC;EApBvC,oBAoB+C;ADyvDjD;;ACvvDA;EA1BE,2EAAA;EACA,eA0B4B;EAzB5B,2BAAA;EACA,mBAwBuC;EAvBvC,oBAuB+C;AD8vDjD;;AC5vDA;EA7BE,2EAAA;EACA,eA6B4B;EA5B5B,2BAAA;EACA,mBA2BuC;EA1BvC,oBA0B+C;ADmwDjD;;AChwDA;EAjCE,8DAAA;EACA,eAiC0B;EAhC1B,2BAAA;EACA,iBA+BqC;EA9BrC,oBA8B2C;ADuwD7C;;ACrwDA;EApCE,8DAAA;EACA,eAoC0B;EAnC1B,2BAAA;EACA,iBAkCqC;EAjCrC,oBAiC2C;AD4wD7C;;AC1wDA;EAvCE,8DAAA;EACA,eAuC0B;EAtC1B,2BAAA;EACA,iBAqCqC;EApCrC,oBAoC2C;ADixD7C;;AC/wDA;EA1CE,8DAAA;EACA,eA0C0B;EAzC1B,2BAAA;EACA,iBAwCqC;EAvCrC,oBAuC2C;ADsxD7C;;ACpxDA;EA7CE,8DAAA;EACA,eA6C0B;EA5C1B,2BAAA;EACA,iBA2CqC;EA1CrC,oBA0C2C;AD2xD7C;;ACzxDA;EAhDE,8DAAA;EACA,eAgD0B;EA/C1B,2BAAA;EACA,iBA8CqC;EA7CrC,oBA6C2C;ADgyD7C;;AC9xDA;;;EAGE,mDA/EU;ADg3DZ;;AYr4DA;EACE,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AZw4DF;;AYr4DA;EACE,qBAAA;EACA,mBAAA;EACA,iCAAA;AZw4DF;;AYr4DA;EACE;IACE,UAAA;EZw4DF;EYt4DA;IACE,UAAA;EZw4DF;AACF;AYt4DA;EACE,6BAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,+CAAA;AZw4DF;;AYr4DA;EACE,oBAAA;EACA,eAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,uFAAA;EACA,wBAAA;EACA,8EAAA;EAIA,gBAAA;AZq4DF;;AYl4DA;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,cXvDM;AD47DR;;AYl4DA;EACE,eAAA;EACA,gBAAA;EACA,cXzDa;AD87Df;;AYl4DA;EACE,eAAA;EACA,gBAAA;AZq4DF;;AYn4DA;EACE,eAAA;AZs4DF;;AYn4DA;EACE,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;AZs4DF;;AYn4DA;EACE,oBAAA;EACA,qBAAA;EACA,oCAAA;AZs4DF;;AA98DA,iCAAA;AACA;;EAEE,oCAAA;EACA,eAAA;AAi9DF;;AA98DA;EACE,qBAAA;AAi9DF;;AA98DA;ECYE,yBAAA;EACA,iBDZoC;ECapC,8BAAA;EACA,2BAAA;EDbA,oBAAA;EACA,eAAA;EACA,yBCzBM;ED0BN,kBAAA;EACA,kBAAA;AAo9DF;;AAj9DA;ECGE,yBAAA;EACA,iBDHmC;ECInC,iCAAA;EACA,2BAAA;ADk9DF;;AAp9DA;EACE,oBAAA;EACA,6BAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;AAu9DF;AAr9DE;EAEE,6BAAA;AAs9DJ;AAp9DE;EAEE,8BAAA;AAq9DJ;;AAj9DA;ECzBE,oCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;AD8+DF;AAt9DE;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;AAw9DJ;;AAp9DA;EClCE,+CAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EDiCA,+CAAA;EACA,2BAAA;AA09DF;AAx9DE;EACE,yBAAA;AA09DJ;;AAt9DA;EC5CE,wCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;ADsgEF;;AA19DA;EC/CE,wCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;AD6gEF;;AA79DA;ECnDE,oCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;ADohEF;AAl+DE;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;AAo+DJ;;AAj+DA;EACE,wBAAA;EACA,2BAAA;AAo+DF;;AAj+DA;EChEE,wCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;ED+DA,mCAAA;EACA,kBAAA;AAu+DF;;AAp+DA;EACE,qBAAA;AAu+DF;;AAp+DA;EC1EE,oCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EDyEA,4BAAA;AA0+DF;AAz+DE;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;AA2+DJ;;AAv+DA;ECpFE,wCAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EDmFA,mCAAA;AA6+DF;AA3+DE;EACE,wCAAA;EACA,yBAAA;AA6+DJ;;AA1+DA;EACE,cCpHa;EDqHb,yBCrHa;EDsHb,SAAA;AA6+DF;;AA3+DA;EACE,aAAA;EACA,uBAAA;AA8+DF;;AA3+DA;EACE,kCAAA;EAAA,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,uBAAA;AA8+DF;;AA3+DA;EACE,YAAA;EACA,sBAAA;AA8+DF;;AA3+DA;EAEE,yBC9IgB;ED+IhB,YAAA;AA6+DF;;AA1+DA;EACE,UAAA;AA6+DF;;AA1+DA;EACE,yBAAA;EACA,oCAAA;EACA,uFAAA;EACA,wBAAA;EACA,oEAAA;AA6+DF;;AA3+DA;EACE,+CAAA;EACA,0BAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,uFAAA;EACA,wBAAA;EACA,oEAAA;AA8+DF;AA1+DE;EACE,iBAAA;AA4+DJ;;AAv+DE;EACE,aAAA;EACA,cAAA;AA0+DJ;;AAt+DA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,uFAAA;EACA,wBAAA;EACA,oEAAA;EACA,sCAAA;AAy+DF;;AAt+DA;EACE,cAAA;EACA,eAAA;AAy+DF;AAx+DE;EACE,eAAA;AA0+DJ;;AAv+DA;EACE,cCxMa;EDyMb,eAAA;EACA,gBAAA;AA0+DF;AAz+DE;EACE,cAAA;AA2+DJ;;AAv+DA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uFAAA;EACA,wBAAA;EACA,8EAAA;AA0+DF;;AAp+DA;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;AAu+DF;;AAr+DA;EACE,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;EACA,sDAAA;AAw+DF;AAt+DE;EACE;IAEE,mBAAA;IACA,UAAA;EAu+DJ;AACF;;AAn+DA;EACE,eAAA;AAs+DF;;AAn+DA,wBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAs+DF;;AAn+DA;EACE,cAAA;EACA,UAAA;AAs+DF;;AAn+DA;EACE,gBAAA;AAs+DF;;AAn+DA;EACE,UAAA;AAs+DF;;AAn+DA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EAEA,gBAAA;EACA,MAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAs+DF;AAp+DE;EACE,aAAA;AAs+DJ;;AAn+DA;EACE,gBAAA;EACA,mBAAA;AAs+DF;;AAp+DA;EACE,gBAAA;EACA,iBAAA;AAu+DF;;AAr+DA;EACE,yBChTc;EDiTd,6BAAA;AAw+DF;;AAt+DA;EACE,qBAAA;AAy+DF;;AAv+DA,yBAAA;AACA;EACE,WAAA;EACA,YAAA;AA0+DF;;AAx+DA;EACE,UAAA;AA2+DF;;AAz+DA;EACE,yBC/Tc;EDgUd,kBAAA;AA4+DF;;AA1+DA,4BAAA;AACA;EACE,UAAA;AA6+DF;;AA3+DA;EACE,yBCvUc;EDwUd,kBAAA;AA8+DF;;AA3+DA,yBAAA;AACA;EACE,yBC7Uc;ED8Ud,cChVM;EDiVN,6BAAA;AA8+DF;;AA5+DA;EACE,yBClVc;EDmVd,qBAAA;AA++DF;;AA7+DA;EACE,gCAAA;AAg/DF;;AA7+DA,oBAAA;AACA;EACE,uCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qBAAA;AAg/DF;;AA7+DA;EACE,yBAAA;EACA,4BAAA;EACA,4BAAA;AAg/DF;;AA7+DA;EACE,6BAAA;EACA,gCAAA;EACA,uEAAA;AAg/DF;;AA7+DA;EACE,eAAA;EACA,yBAAA;AAg/DF;;AA7+DA;EACE,qDAAA;AAg/DF;;AA9+DA,yBAAA;AACA;EACE,WAAA;EACA,6BAAA;AAi/DF;;AA9+DA;EACE,aAAA;EACA,qBAAA;EACA,yBC3Xe;AD42EjB;;AA9+DA;EACE,oBAAA;AAi/DF;;AA9+DA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,yBC7YgB;ED8YhB,cC7Ya;ED8Yb,gBAAA;AAi/DF;;AA/+DA;EACE,oBAAA;AAk/DF;;AA/+DA,yBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAk/DF;;AAh/DA;EACE,uBAAA;EAAA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,UAAA;AAm/DF;;AAh/DA;EACE,mBAAA;AAm/DF;;AAh/DA;EACE,yBAAA;EACA,wCAAA;EACA,YAAA;EACA,gBAAA;AAm/DF;;AAh/DA;EACE,iCAAA;AAm/DF;;AAj/DA;EACE,iCAAA;AAo/DF;;AAj/DA;EACE,oCAAA;EACA,yBAAA;AAo/DF;;AAj/DA;EACE,oCAAA;EACA,yBAAA;AAo/DF;;AAl/DA;EACE,yBAAA;EACA,2BAAA;AAq/DF;;AAl/DA,wBAAA;AACA;EACE,eAAA;AAq/DF;;AAl/DA,yBAAA;AACA;EACE,yBAAA;AAq/DF;;AAl/DA,oBAAA;AACA;EACE,oCAAA;EACA,gBAAA;EACA,6BAAA;AAq/DF;;AAl/DA;EACE,iCAAA;AAq/DF;;AAn/DA;EACE;IACE,UAAA;EAs/DF;EAp/DA;IACE,UAAA;EAs/DF;AACF;AAp/DA;EACE,2BAAA;AAs/DF;;AAn/DA;EACE,oCAAA;EACA,gBAAA;EACA,eAAA;AAs/DF;;AAn/DA;EACE,yBC5eY;ADk+Ed;;AAn/DA;EACE,0BAAA;AAs/DF;;AAn/DA;EACE,oCAAA;EACA,aAAA;AAs/DF;;AAn/DA;EACE,wBAAA;AAs/DF;;AAn/DA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAs/DF;;AAp/DA;EACE,cC/fa;ADs/Ef;AAt/DE;EACE,cAAA;AAw/DJ;;AAr/DA;EACE,yBAAA;EACA,cCtgBa;AD8/Ef;;AAr/DA,wBAAA;AACA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;AAw/DF;;AAr/DA;EACE,0BAAA;EACA,eAAA;AAw/DF;;AAr/DA,oBAAA;AACA;EACE,0BAAA;EACA,+BAAA;AAw/DF;AAv/DE;EACE,0BAAA;EACA,6BAAA;AAy/DJ;;AAr/DA,kBAAA;AACA;EACE,mBCxhBQ;EDyhBR,2BAAA;EACA,cC1iBM;ADkiFR;;AAt/DA;EACE,wBAAA;AAy/DF;;AAt/DA,sBAAA;AACA;EACE,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBCnjBc;AD4iFhB;;AAt/DA;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAy/DF;;AAr/DA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AAw/DF;;AAp/DA;EACE,cAAA;AAu/DF;;AAp/DA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;AAu/DF;;AAp/DA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAu/DF;;AAn/DA;EACE,wBAAA;EACA,6BAAA;EACA,mCAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;EACA,2EAAA;EACA,4BAAA;AAs/DF;AA1+DA;EACE;IACE,8BAAA;EAq/DF;EAn/DA;IACE,6BAAA;EAq/DF;AACF","sourcesContent":["@import \"index.scss\";\n@import \"Footer.scss\";\n@import \"Header.scss\";\n@import \"Auth-forms.scss\";\n@import \"Dash-cards.scss\";\n@import \"Notification.scss\";\n@import \"Responsive.scss\";\n@import \"Comment.scss\";\n@import \"Suggested.scss\";\n@import \"Calendar.scss\";\n@import \"Vertical-nav.scss\";\n@import \"Timeline.scss\";\n\n/*------General Components------*/\nhtml,\nbody {\n  background-color: $secondary-light !important;\n  font-size: 1rem;\n}\n\n:any-link {\n  text-decoration: none;\n}\n\n.titleText {\n  @include title-text($primary-light, 1.5rem, 0px, 700);\n  font-family: Poppins;\n  padding: 0.4rem;\n  background-color: $theme;\n  width: max-content;\n  border-radius: 8px;\n}\n\n.subTitle {\n  @include title-text($primary-dark, 1.5rem, normal, 700);\n}\n\n.section-header p {\n  margin-left: 0.25rem;\n  font-size: $size-lg !important;\n  font-weight: 500 !important;\n  margin-bottom: 8px;\n  color: lighten($primary-dark, 20);\n\n  &.sm {\n    @extend .section-header;\n    font-size: $size-sm !important;\n  }\n  &.md {\n    @extend .section-header;\n    font-size: $size-md !important;\n  }\n}\n\n.btn-primary {\n  @include btn-style($button-bg, $button-text, none, 600);\n  &:hover {\n    background-color: $button-hover !important;\n    color: $primary-light !important;\n    border: none;\n  }\n}\n\n.btn-primary.btn-muted {\n  @include btn-style(rgb(246, 248, 250), $fnt-muted, none, 500);\n  border: 1px solid rgb(208, 215, 222) !important;\n  padding: 0.25rem !important;\n\n  &:hover {\n    color: $fnt-muted !important;\n  }\n}\n\n.btn-cancel {\n  @include btn-style(transparent, $primary-dark, none, 600);\n}\n.btn-cancel:hover {\n  @include btn-style(transparent, $theme, none, 600);\n}\n\n.btn-danger {\n  @include btn-style($button-danger-bg, $button-danger-text, none, 600);\n  &:hover {\n    background-color: $button-danger-hover !important;\n    color: $primary-light !important;\n    border: none;\n  }\n}\n:is(.btn-primary:focus, .btn:focus) {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.btn-placements {\n  @include btn-style(transparent, $theme, none, 600);\n  padding: 2px 8px 4px 8px !important;\n  margin: 1rem 0 0 0;\n}\n\n.btn-placements:not(:first-child) {\n  margin: 1rem 0 0 1rem;\n}\n\n.formBtn.btn-primary {\n  @include btn-style($button-bg, $button-text, none, 600);\n  padding: 5px 10px !important;\n  &:hover {\n    background-color: $button-hover !important;\n    color: $primary-light !important;\n    border: none;\n  }\n}\n\n.postBtn-placements {\n  @include btn-style(transparent, $primary-dark, none, 600);\n  padding: 2px 8px 4px 8px !important;\n  // margin: 0 0 0 0.5rem;\n  &:hover {\n    background-color: transparent !important;\n    color: $theme !important;\n  }\n}\n.divider {\n  color: $primary-dark;\n  background-color: $primary-dark;\n  height: 1;\n}\n.centerContent {\n  display: flex;\n  justify-content: center;\n}\n\n.toasts {\n  width: fit-content !important;\n  top: 10px;\n  margin-left: 4px;\n  font-weight: 500;\n  background-color: $primary-light !important;\n  border: none !important;\n}\n\n.toasts-icon {\n  padding: 2px;\n  border-radius: 0.25rem;\n}\n\ndiv.content {\n  // padding: 80px 0;\n  background-color: $secondary-light;\n  height: 100%;\n}\n\n.userInfo-div button {\n  padding: 0;\n}\n\n%vote_btn-interactive {\n  color: #5850ec !important;\n  background-color: #e5edff !important;\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n  --bs-border-opacity: 0.1;\n  border-color: rgba(#5850ec, var(--bs-border-opacity)) !important;\n}\n.vote_btn {\n  padding: 0.2rem 0.4rem 0.2rem 0.4rem !important;\n  font-size: 12px !important;\n  font-weight: 600;\n  background-color: #f9fafb !important;\n  color: #475569 !important;\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n  --bs-border-opacity: 0.1;\n  border-color: rgba(#475569, var(--bs-border-opacity)) !important;\n  &:hover {\n    @extend %vote_btn-interactive;\n  }\n  & svg {\n    fill: transparent;\n  }\n}\n.vote_btn.user_vote {\n  @extend %vote_btn-interactive;\n  & svg {\n    fill: #eac54f;\n    color: #eac54f;\n  }\n}\n\n#vote_badge {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  background-color: #e5edff !important;\n  color: #5850ec !important;\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n  --bs-border-opacity: 0.1;\n  border-color: rgba(#5850ec, var(--bs-border-opacity)) !important;\n  padding: 0.25rem 0.5rem 0.25rem 0.5rem;\n}\n\n.username_tags {\n  color: #0d6efd;\n  font-size: 14px;\n  &:hover {\n    cursor: pointer;\n  }\n}\n.username_tags-dark {\n  color: $primary-dark;\n  font-size: 14px;\n  font-weight: 600;\n  &:hover {\n    color: #0d6efd;\n  }\n}\n\n#badgeItem {\n  font-size: 11px;\n  font-weight: 600;\n  display: inline-flex;\n  position: relative;\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n  --bs-border-opacity: 0.1;\n  border-color: rgba(\n    var(--bs-success-rgb),\n    var(--bs-border-opacity)\n  ) !important;\n}\n\n.pulse_dot {\n  display: inline-flex;\n  position: absolute;\n  top: 0rem;\n  right: 0rem;\n  width: 0.4rem;\n  height: 0.4rem;\n  border-radius: 9999px;\n  background-color: #dc2626;\n}\n.animate_pulse {\n  display: inline-flex;\n  position: absolute;\n  top: 0rem;\n  right: 0rem;\n  width: 0.4rem;\n  height: 0.4rem;\n  border-radius: 9999px;\n  background-color: #dc2626;\n  opacity: 0.75;\n  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n\n  @keyframes ping {\n    75%,\n    100% {\n      transform: scale(2);\n      opacity: 0;\n    }\n  }\n}\n\n.cursor-event {\n  cursor: pointer;\n}\n\n/*------Main Dash------*/\n.dash-container {\n  display: flex;\n  flex-direction: row;\n  flex: 0 1 auto;\n  min-height: 100vh;\n  margin: 0 auto;\n  max-width: 85rem;\n}\n\n.dash-container .content {\n  flex: 1 1 auto;\n  width: 60%;\n}\n\n.dash-container#main .container {\n  max-width: 41rem;\n}\n\n.sidebar {\n  width: 30%;\n}\n\n.sidebar-wrapper {\n  width: 100%;\n  overflow: auto;\n  height: 100vh;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n.sidebar_right {\n  margin-top: 20px;\n  padding-right: 10px;\n}\n.sidebar_left {\n  margin-top: 20px;\n  padding-left: 5px;\n}\n.sidebar .card {\n  background-color: $primary-light;\n  border-radius: 8px !important;\n}\n.content-wrapper {\n  margin: 20px 0 20px 0;\n}\n/*------Event Dash------*/\n.sidebar_eventDash-wrapper {\n  width: 100%;\n  height: 100%;\n}\n.sidebar_eventDash {\n  width: 40%;\n}\n.sidebar_eventDash .card {\n  background-color: $primary-light;\n  border-radius: 8px;\n}\n/*------Calendar Dash------*/\n.sidebar_calendarDash {\n  width: 32%;\n}\n.sidebar_calendarDash .card {\n  background-color: $primary-light;\n  border-radius: 8px;\n}\n\n/*------Off-Canvas------*/\n.offcanvas-header {\n  background-color: $primary-light;\n  color: $theme;\n  padding: 20px 30px !important;\n}\n.offcanvas-body {\n  background-color: $primary-light;\n  padding: 0 !important;\n}\n.offcanvas.offcanvas-end {\n  border-color: $theme-light !important;\n}\n\n/*------Modal------*/\n.modal-header {\n  border-top-right-radius: 8px !important;\n  border-top-left-radius: 8px !important;\n  border-color: transparent !important;\n  padding: 0 !important;\n}\n\n.modal-title {\n  color: $primary-dark !important;\n  font-weight: bold !important;\n  font-size: 1.2rem !important;\n}\n\n.modal-content {\n  border-radius: 8px !important;\n  border-color: $primary-light !important;\n  box-shadow: 0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%);\n}\n\n.modal-body {\n  font-size: 1rem;\n  color: rgb(107 114 128);\n}\n\n.modal-backdrop {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n/*------Image/Logo------*/\n.userProf-img {\n  width: 45px;\n  border-radius: 4px !important;\n}\n\n.members-img {\n  width: 1.5rem;\n  border-radius: 9999px;\n  background-color: $secondary-dark;\n}\n\n.img-group img {\n  margin-left: -0.6rem;\n}\n\n.members-count {\n  display: inline-flex;\n  overflow: hidden;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 9999px;\n  background-color: $secondary-light;\n  color: $primary-dark;\n  font-size: small;\n}\n.img-group span {\n  margin-left: -0.6rem;\n}\n\n/*------pagination------*/\n.paginate_div {\n  display: flex;\n  justify-content: flex-end;\n  margin: 20px;\n  padding: 10px 0;\n}\n.pagination #pagi-container {\n  width: fit-content;\n  background-color: transparent;\n  border-radius: 10px;\n  padding: 0;\n}\n\n#pagi-container li {\n  margin: 0 5px 0 5px;\n}\n\n.pagination .page-link {\n  color: $secondary-dark !important;\n  background-color: transparent !important;\n  border: none;\n  font-weight: 500;\n}\n\n.pagination #prev {\n  border-radius: 0.25rem !important;\n}\n.pagination #next {\n  border-radius: 0.25rem !important;\n}\n\n.pagination .page-item.active .page-link {\n  background-color: $button-bg !important;\n  color: $button-text !important;\n}\n\n.pagination .page-link:hover {\n  background-color: $button-bg !important;\n  color: $button-text !important;\n}\n.pagination .page-item.disabled .page-link {\n  color: $fnt-muted !important;\n  font-weight: 400 !important;\n}\n\n/*------Listgroup------*/\n.members-list.list-group .list-group-item {\n  padding: 10px 0;\n}\n\n/*------Breadcrumb------*/\n.breadcrumb :not(.breadcrumb-item.active) {\n  color: $theme !important;\n}\n\n/*------Table------*/\n.custom-table {\n  border: 1px solid darken($primary-light, 10) !important;\n  overflow: hidden;\n  border-radius: 8px !important;\n}\n\n.custom-table tr {\n  animation: displayTransition 0.2s;\n}\n@keyframes displayTransition {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.custom-table table {\n  margin-bottom: 0 !important;\n}\n\n.custom-table th {\n  background-color: $theme-light !important;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.custom-table tbody tr:hover td {\n  background-color: $theme-light;\n}\n\n.custom-table tbody tr:nth-last-of-type(1) {\n  border-bottom: transparent;\n}\n\n.custom-table .badge {\n  background-color: $theme !important;\n  padding: 10px;\n}\n\n.custom-table .table-content {\n  padding: 5px 2px 5px 2px;\n}\n\n.custom-table .table-content h4 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.custom-table .table-content h4 a {\n  color: $primary-dark;\n  &:hover {\n    color: #0d6efd;\n  }\n}\n.custom-table .dropdown button {\n  border: 1px solid #dee2e6;\n  color: $primary-dark;\n}\n\n/*------Not Found------*/\n.not-found {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  margin: 0rem auto 0rem auto;\n  text-align: center;\n  padding: 3rem;\n}\n\n.not-found a {\n  text-decoration: underline;\n  font-size: 14px;\n}\n\n/*------Alert------*/\n.alert-dismissible {\n  border-width: 0 !important;\n  padding: 0.5rem 1rem !important;\n  .btn-close {\n    font-size: 10px !important;\n    padding: 1rem 1rem !important;\n  }\n}\n\n/*------Tag------*/\n#dropdown-tag {\n  font-size: $size-md;\n  font-weight: 600 !important;\n  color: $theme;\n}\n#dropdown-tag.dropdown-toggle::after {\n  display: none !important;\n}\n\n/*------Loaders------*/\n.loading_skeleton {\n  border: 1px solid rgba(0, 0, 0, 0.175);\n  margin-bottom: 10px;\n  border-radius: 8px;\n  background-color: $primary-light;\n}\n\n.loading_skeleton .title {\n  width: 270px;\n  height: 25px;\n  background-color: #e5e7eb;\n  border-radius: 4px;\n  @extend %load-effect;\n}\n\n.loading_skeleton .img {\n  border-radius: 4px;\n  padding: 20px;\n  margin-top: 10px;\n  background-color: #d1d5db;\n  display: flex;\n  justify-content: center;\n  @extend %load-effect;\n}\n\n.loading_skeleton .img svg {\n  color: #e5e7eb;\n}\n\n.loading_skeleton .circle {\n  width: 20px;\n  height: 20px;\n  background-color: #e5e7eb;\n  border-radius: 1000px;\n  @extend %load-effect;\n}\n.loading_skeleton .btn {\n  width: 67px;\n  height: 30px;\n  background-color: #e5e7eb;\n  border-radius: 8px;\n  @extend %load-effect;\n}\n\n%load-effect {\n  animation-duration: 2.2s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: shimmer;\n  animation-timing-function: linear;\n  background: #ddd;\n  background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);\n  background-size: 1200px 100%;\n}\n\n@-webkit-keyframes shimmer {\n  0% {\n    background-position: -100% 0;\n  }\n  100% {\n    background-position: 100% 0;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1200px 0;\n  }\n  100% {\n    background-position: 1200px 0;\n  }\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Roboto:wght@100;300;400;500;700;900&display=swap\");\n\n/*------Color Pallet------*/\n$theme: #6366f1;\n$theme-light: #f2f3fa;\n$primary-light: #ffffff;\n$secondary-light: #f7f7f7;\n$primary-dark: #2c2f33;\n$secondary-dark: #23272a;\n$fnt-muted: #6c757d;\n$button-bg: #e0e7ff;\n$button-text: #3730a3;\n$button-hover: #3730a3;\n$button-danger-bg: #fee2e2;\n$button-danger-text: #dc2626;\n$button-danger-hover: #ef4444;\n\n/*------Font------*/\n$size-sm: 0.75rem;\n$size-md: 0.875rem;\n$size-lg: 1.25rem;\n\n$font-header: \"Poppins\", \"Roboto\", \"sans-serif\", Arial, Helvetica;\n$font-body: \"Roboto\", sans-serif, Arial, Helvetica;\n\n/*------Mixin------*/\n\n//Button\n@mixin btn-style($bgColor, $color, $border, $fw) {\n  background-color: $bgColor !important;\n  color: $color !important;\n  border: $border !important;\n  font-weight: $fw !important;\n}\n\n@mixin title-text($color, $fs, $ltrspace, $fw) {\n  color: $color !important;\n  font-size: $fs;\n  letter-spacing: $ltrspace !important;\n  font-weight: $fw !important;\n}\n\n@mixin header-footer-font($fntSize, $fntFam, $fntW) {\n  font-size: $fntSize;\n  font-family: $fntFam;\n  font-weight: $fntW;\n}\n@mixin font($fntFam, $fntSize, $fntW, $lineH, $fontStyle) {\n  font-family: $fntFam !important;\n  font-size: $fntSize;\n  font-weight: $fntW !important;\n  line-height: $lineH;\n  font-style: $fontStyle;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: $font-body, -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  scroll-behavior: smooth;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nh1 {\n  @include font($font-header, 56px, 600, 67.2px, \"normal\");\n}\nh2 {\n  @include font($font-header, 48px, 600, 57.6px, \"normal\");\n}\nh3 {\n  @include font($font-header, 22px, 600, 26.4px, \"normal\");\n}\n\n.content_1 {\n  @include font($font-body, 20px, 400, 30px, \"normal\");\n}\n.content_sm1 {\n  @include font($font-body, 16px, 400, 24px, \"normal\");\n}\n.content_sm3 {\n  @include font($font-body, 12px, 400, 18px, \"normal\");\n}\n.content_sm4 {\n  @include font($font-body, 18px, 600, 27px, \"normal\");\n}\n.content_sm5 {\n  @include font($font-body, 14px, 400, 18px, \"normal\");\n}\np {\n  @include font($font-body, 20px, 400, 30px, \"normal\");\n}\na,\nh5,\nh6 {\n  font-family: $font-body;\n}\n","@import \"index.scss\";\n\n/*------Footer------*/\n.footer {\n  background-color: $theme-light;\n  width: 100%;\n}\n.footer-container {\n  padding: 20px;\n}\n.footer-logo {\n  text-align: start;\n}\n.footer-links {\n  text-align: end;\n}\n.footer-links > span > a {\n  color: $primary-dark;\n  text-decoration: none;\n  font-size: 0.8rem;\n  font-weight: 600;\n  transition: all 0.2s;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.footer-links > span > a:hover {\n  color: $theme;\n  text-decoration: underline;\n}\n\n.footer small {\n  font-size: $size-sm;\n}\n","@import \"index.scss\";\n\n/*------Header Nav------*/\n.navbar {\n  @include header-footer-font(0.875rem, sans-serif, 600);\n  z-index: 1000;\n}\n\n.nav_userProf {\n  width: 25px;\n  border-radius: 8px !important;\n  background-color: $secondary-dark;\n}\n\n.navbar-brand {\n  color: $theme !important;\n}\n\n.navbar-nav .nav-link {\n  color: $fnt-muted !important;\n}\n\n.navbar-nav .nav-link:hover {\n  color: $theme !important;\n}\n\n.navbar .container {\n  max-width: 85rem;\n}\n\na.dropdown-item:hover {\n  background-color: transparent;\n  color: $theme !important;\n}\n\n.header-blur {\n  background-color: hsla(0, 0%, 100%, 0.8);\n  backdrop-filter: saturate(180%) blur(5px);\n  -webkit-backdrop-filter: saturate(180%) blur(5px);\n}\n\n.navbar .dropdown-menu a {\n  @include header-footer-font(0.875rem, sans-serif, 500);\n  color: $fnt-muted !important;\n  &:hover {\n    color: $theme !important;\n  }\n}\n.navbar .dropdown-menu.show {\n  right: 0;\n  left: auto;\n}\n.navbar .dropdown-menu.show a:hover {\n  background-color: $secondary-light;\n}\n\n.navbar .dropdown-toggle::after {\n  display: none !important;\n}\n\n.navbar .button-wrapper {\n  background-color: transparent !important;\n  cursor: auto !important;\n}\n\n//notification\n#notification-icon {\n  display: inline-flex;\n  position: relative;\n  align-items: center;\n  padding: 0.75rem;\n}\n.notification-badge {\n  display: inline-flex;\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  width: 0.5rem;\n  height: 0.5rem;\n  font-size: x-small;\n  font-weight: bold;\n  color: white;\n  background-color: red;\n  border-radius: 50px;\n  border-width: 2px;\n  border-color: white;\n}\n","@import \"index.scss\";\n\n/*------Login/Signup Forms------*/\ndiv#auth-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n.auth-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 24px;\n  flex: 1 1;\n}\n.auth-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 80px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.login-card .form-control:-webkit-autofill {\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.login-card .form-control:focus {\n  border: 1px solid $theme;\n  box-shadow: none !important;\n  background-color: rgba($primary-light, 0.5);\n}\n\n.login-card .form-control {\n  border: 1px solid rgba($primary-dark, 0.1);\n  background-color: transparent;\n}\n\n.new-post-container .form-control:hover {\n  border: 1px solid $theme;\n}\n\n.login-card.card {\n  background-color: transparent;\n  border: none;\n  color: $primary-dark;\n  font-weight: 500;\n  width: 100%;\n  max-width: 500px !important;\n  padding: 1.5rem 2rem 2rem 2rem;\n}\n\n.btn-primary.show_hide-pw {\n  background-color: $button-bg !important;\n  color: $theme !important;\n\n  &:hover {\n    background-color: $button-bg !important;\n    color: $button-text !important;\n  }\n}\n\n//current user\n.current-signedin .list-group-item:hover {\n  transition: all 0.2s;\n  background-color: $secondary-light;\n}\n\n//otp card\n/* Chrome, Safari, Edge, Opera */\n.otp-card,\ninput::-webkit-outer-spin-button,\n.otp-card,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n.otp-card input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.otp-card a {\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.otp-card .message-block {\n  font-size: 14px;\n  margin-bottom: 10px !important;\n}\n","@import \"index.scss\";\n\n/*------Dash Cards------*/\n.create_event-card {\n  background-color: $primary-light !important;\n  border-radius: 8px !important;\n  padding: 20px;\n  margin: 20px;\n}\n.create_event-card .card-header {\n  background-color: transparent;\n  border: none;\n  border-radius: 5px;\n  padding: 1rem 1rem;\n}\n.new-post-container {\n  color: $primary-dark;\n  border-radius: 5px;\n}\n\n.editor-card {\n  background-color: $primary-light !important;\n  border-radius: 8px !important;\n  margin-top: 20px;\n  border: none !important;\n}\n.editor-card .card-header {\n  background-color: transparent !important;\n  padding: 1rem 1rem;\n  border: none;\n}\n\n:is(.new-post-container, .editor-card) :is(.form-control, .form-control) {\n  color: $primary-dark;\n}\n\n:is(.new-post-container, .editor-card)\n  :is(\n    .form-control:focus,\n    .form-control:focus,\n    .ql-editor:focus,\n    .dateTimePicker\n      .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused\n      .MuiOutlinedInput-notchedOutline\n  ) {\n  border-color: $theme !important;\n  box-shadow: none !important;\n  &.ql-editor {\n    border: 1px solid $theme !important;\n  }\n  &.MuiOutlinedInput-notchedOutline {\n    border-width: 1px;\n  }\n}\n\n:is(.new-post-container, .editor-card)\n  :is(\n    .form-control,\n    .form-control,\n    .dateTimePicker .css-1d3z3hw-MuiOutlinedInput-notchedOutline\n  ) {\n  border: 1px solid rgba($primary-dark, 0.1);\n}\n\n.new-post-container .form-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n//event\n.event-card {\n  background-color: $primary-light !important;\n  border-radius: 8px !important;\n  padding: 20px;\n  margin-top: 20px;\n}\n\n.event-card .card-header {\n  background-color: transparent;\n  border: none;\n  border-radius: 5px;\n  padding: 1rem 1rem;\n}\n\n.event-card .details_textarea {\n  background-color: $secondary-light;\n  border-radius: 8px;\n  padding: 25px;\n  &:not(:first-child) {\n    background-color: $primary-light !important;\n  }\n}\n\n.event-card .cta_button {\n  max-width: fit-content !important;\n}\n\n.event-card_dash .dropdown-toggle.btn,\n.event-card .dropdown-toggle.btn {\n  padding: 0;\n  justify-content: center;\n  background-color: transparent;\n  border: none;\n}\n\n.event-card_dash .dropdown-toggle::after,\n.event-card .dropdown-toggle::after {\n  display: none !important;\n}\n.event-card div[aria-labelledby=\"dropdown-basic\"] button {\n  width: 100%;\n  &:hover {\n    background-color: $button-bg !important;\n  }\n}\n/* .event-card div[aria-labelledby=\"dropdown-basic\"] {\n  min-width: 100px !important;\n} */\n\n// Dashboard\n.event-card_dash {\n  margin: 20px;\n  animation: displayTransition 0.2s;\n}\n@keyframes displayTransition {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.event-card_dash #card_header {\n  padding: 0 0.4rem 10px 0.4rem;\n}\n.event-card_dash #card_header .card-timestamp {\n  font-size: 12px;\n  &::before {\n    padding: 0 1.5px 0 1.5px;\n    margin: 0 2px 0 2px;\n    content: \"\\2022\";\n    font-weight: 700;\n  }\n}\n.userProf-img#card-img {\n  width: 25px;\n}\n\n.event-card_dash .card {\n  background-color: $primary-light !important;\n  border-radius: 8px !important;\n}\n\n.event-card_dash .card .card-footer {\n  background-color: $primary-light;\n  border-top: none;\n  border-bottom-left-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n  text-align: end;\n}\n.event-card_dash .card .card-footer a {\n  color: $fnt-muted !important;\n  font-size: 14px;\n}\n\n.event-card_dash .event-brief small {\n  font-size: 12px;\n}\n.event-card_dash .event-brief h4 {\n  font-size: 16px;\n  font-weight: 600;\n}\n.event-card_dash .event-brief p {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.event-card_dash div[role=\"group\"] button {\n  max-height: 36px !important;\n}\n\n//quill editor\n.ql-toolbar.ql-snow {\n  border: 1px solid rgba($primary-dark, 0.1) !important;\n  border-radius: 0.375rem 0.375rem 0 0 !important;\n  border-bottom: none !important;\n}\n.ql-container.ql-snow {\n  border: none !important;\n}\n\n.ql-editor {\n  border: 1px solid rgba($primary-dark, 0.1) !important;\n  border-radius: 0 0 0.375rem 0.375rem !important;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n\n.ql-editor span {\n  font-size: 1rem !important;\n}\n\n//MUI Custom\n.dateTimePicker.css-z3c6am-MuiFormControl-root-MuiTextField-root {\n  display: block !important;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n.dateTimePicker\n  :is(\n    .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root,\n    .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root\n  ) {\n  line-height: 1.5;\n  padding: 0;\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  appearance: none;\n  border-radius: var(--bs-border-radius);\n}\n\n.dateTimePicker input {\n  padding: 0.375rem 0.75rem;\n  width: 100%;\n  height: auto;\n  margin: 1px;\n}\n\n.dateTimePicker .css-1laqsz7-MuiInputAdornment-root {\n  display: none !important;\n}\n\n:is(\n    .dateTimePicker .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root:hover,\n    .dateTimePicker\n      .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-error\n  )\n  .MuiOutlinedInput-notchedOutline {\n  border-color: rgba($primary-dark, 0.1) !important;\n}\n","@import \"index.scss\";\n\n/*------Notification------*/\n.notif-button-item {\n  padding: 15px 30px 0 !important;\n  width: 100%;\n  text-align: left !important;\n  text-decoration: none !important;\n  color: $primary-dark !important;\n  border: none !important;\n  border-radius: 0 !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n.notif-button-item:hover {\n  background-color: $theme-light;\n  color: $theme !important;\n}\n.notif-button-item hr {\n  margin-bottom: 0;\n  color: $theme;\n}\n.notif-subHeader .content {\n  padding: 5px 30px 0 !important;\n  background-color: transparent;\n}\n.notif-mark {\n  color: $theme;\n  vertical-align: top;\n}\n\n.notif-details-header {\n  font-size: 12px;\n}\n","@import \"index.scss\";\n\n/*------Resposive------*/\n\n@media only screen and (min-width: 575px) {\n  .responsive-elements {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .navbar .navbar-collapse div {\n    margin: 0 !important;\n  }\n  .navbar .navbar-collapse .navbar-nav:first-child .nav-link {\n    background-color: $secondary-light;\n    margin-top: 5px;\n    padding: 10px;\n    border-radius: 8px;\n  }\n  .navbar .navbar-collapse .navbar-nav:nth-child(2) {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 640px) {\n  .login-card.card {\n    width: 100% !important;\n  }\n  .footer-links,\n  .footer-logo {\n    text-align: center;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .sidebar,\n  .sidebar_calendarDash .card {\n    display: none;\n  }\n  .dash-container {\n    margin: 0 auto !important;\n    flex-direction: column-reverse !important;\n  }\n  .dash-container .content {\n    width: 100% !important;\n  }\n  .sidebar_eventDash,\n  .sidebar_calendarDash {\n    width: 100% !important;\n  }\n  .dash-container#calendar {\n    margin: 0 auto !important;\n  }\n  .sidebar-wrapper {\n    height: 100% !important;\n  }\n\n  .sidebar_calendarDash .sidebar-wrapper .sidebar_right {\n    margin-top: 0 !important;\n    padding: 0 !important;\n  }\n}\n\n@media only screen and (min-width: 1450px) {\n  .dash-container {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .navbar .container {\n    max-width: 82rem;\n  }\n}\n","@import \"index.scss\";\n\n//create-comment\n.comment-card {\n  background-color: $primary-light !important;\n  border-radius: 8px !important;\n  margin-top: 20px;\n}\n.comment-card textarea {\n  background-color: transparent;\n  resize: none;\n  border: none;\n  line-height: 1.5rem;\n  font-size: $size-md;\n  display: block;\n  border-width: 0px;\n\n  &:focus {\n    box-shadow: none;\n  }\n}\n\n.user-img {\n  width: 38px !important;\n  height: 100%;\n}\n\n//comment-item\n.comment-item {\n  background-color: $primary-light;\n  border-radius: 8px !important;\n  margin: 0 0 10px 0px;\n  padding: 10px;\n  width: 100%;\n}\n\n.comment-item .card-header {\n  background-color: transparent;\n  border: none;\n  border-radius: 5px;\n}\n\n.comment-item .card-body {\n  padding: 5px 16px 5px 16px;\n}\n\n.comment-item .cta_button {\n  max-width: fit-content !important;\n}\n\n.comment-item div[aria-labelledby=\"dropdown-basic\"] button {\n  width: 100%;\n  &:hover {\n    background-color: $button-bg !important;\n  }\n}\n","@import \"index.scss\";\n\n.suggested img {\n  border-radius: 4px;\n}\n\n.suggested li {\n  margin-top: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.175) !important;\n  border-radius: 8px;\n}\n\n.suggested .badge {\n  font-size: 10px;\n  background-color: $theme-light !important;\n  color: #4338ca;\n  align-self: center;\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n  --bs-border-opacity: 0.1;\n  border-color: rgba(\n    var(--bs-success-rgb),\n    var(--bs-border-opacity)\n  ) !important;\n}\n","@import \"index.scss\";\n\n/*------Calendar------*/\n.calendar-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n.calendar_container {\n  width: 336px;\n  height: 336px;\n  display: flex;\n  flex-direction: column;\n}\n\n.calendar_container .head {\n  height: 38px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n}\n\n.calendar {\n  border: 1px solid darken($primary-light, 10);\n  border-radius: 9px !important;\n  background-color: $primary-light;\n  overflow: hidden;\n}\n\n.calendar table {\n  margin-bottom: 0 !important;\n}\n\n.calendar tbody tr:nth-last-of-type(1) {\n  border-bottom: transparent;\n}\n\n.calendar tbody tr {\n  border-style: hidden !important;\n}\n\n.calendar .table th {\n  background-color: $theme-light;\n  font-size: 14px;\n  color: $theme;\n  font-weight: 600;\n  text-align: center;\n  &:first-child {\n    border-top-left-radius: 7.5px;\n  }\n  &:last-child {\n    border-top-right-radius: 7.5px;\n  }\n}\n\n.calendar .day p {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 400 !important;\n  color: #adadad;\n  text-align: center;\n  transition: 0.2s;\n  padding: 6px;\n\n  &:hover {\n    background-color: $theme-light;\n    border-radius: 6px !important;\n    cursor: default;\n  }\n}\n\n.calendar .day {\n  padding: 5px;\n  width: 25px;\n  height: 25px;\n}\n\n.calendar .currMonth p {\n  color: $fnt-muted;\n}\n\n.calendar .selectedDay p {\n  color: $theme;\n  font-weight: bold !important;\n  border-radius: 6px;\n  background-color: $theme-light;\n}\n\n.calendar .hasEvent p {\n  position: relative;\n  color: $theme;\n  font-weight: bold !important;\n\n  &::before {\n    content: \".\";\n    position: absolute;\n    bottom: 0.1em;\n    left: 0;\n    text-align: center;\n    width: 100%;\n    font-size: 35px;\n  }\n}\n\n.calendar_container .month-controls {\n  display: flex;\n  align-items: center;\n}\n\n.calendar_container .month-controls div {\n  padding: 2px;\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.calendar_container .month-controls h6 {\n  width: 75px;\n  margin: 0 18px 0 18px !important;\n  text-align: center;\n}\n\n.calendar_container .head span {\n  font-size: 20px;\n  font-weight: 600;\n}\n","@import \"index.scss\";\n\n.verticalNav .nav-link {\n  padding-block: 6px;\n  padding-inline: 8px;\n  border-radius: 6px;\n  margin: 1px;\n  color: $primary-dark !important;\n  &:hover {\n    background-color: $theme-light;\n  }\n}\n\n.verticalNav .nav-link.active {\n  font-weight: bold;\n  background-color: $theme-light;\n  border: 1px solid darken($theme-light, 10);\n}\n\n#profile_sidebar {\n  max-width: 20%;\n}\n\n#profile_sidebar .sidebar_left {\n  padding-left: 0;\n}\n","@import \"index.scss\";\n\n.timeline {\n  position: relative;\n  border-left: 1px solid darken($primary-light, 20);\n  list-style: none;\n  padding: 0 !important;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.timeline li {\n  margin-bottom: 2.5rem;\n  margin-left: 1.5rem;\n  animation: displayTransition 0.2s;\n}\n\n@keyframes displayTransition {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.timeline .icon {\n  position: absolute !important;\n  display: flex !important;\n  justify-items: center !important;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 9999px;\n  left: -0.75rem;\n  box-shadow: inset 0 0 0 calc(8px + 4px) $secondary-light !important;\n}\n\n.timeline li .badge {\n  margin-left: 0.85rem;\n  font-size: 12px;\n  background-color: $theme-light !important;\n  color: #4338ca;\n  align-self: center;\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n  --bs-border-opacity: 0.1;\n  border-color: rgba(\n    var(--bs-success-rgb),\n    var(--bs-border-opacity)\n  ) !important;\n  font-weight: 500;\n}\n\n.timeline .icon svg {\n  display: flex;\n  justify-self: center;\n  align-self: center;\n  width: 1.1rem;\n  height: 1.1rem;\n  color: $theme;\n}\n\n.timeline li h5 a {\n  font-size: 18px;\n  font-weight: 600;\n  color: $primary-dark;\n}\n\n.timeline li time {\n  font-size: 14px;\n  font-weight: 500;\n}\n.timeline li p {\n  font-size: 16px;\n}\n\n.timeline_date {\n  padding: 0.375rem 0 0.375rem 0;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid darken($primary-light, 20);\n  height: 18px;\n}\n\n.timeline_date span {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  background-color: $secondary-light !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
